import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_SETTINGS;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function update(param = {}) {
  return wsService.make_post_request(section + "/update", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function getLogo(param = {}) {
  return wsService.make_get_request(section + "/get-logo", param);
}

function alias_get_map(param = {}) {
  return wsService.make_post_request(section + "/alias/get-map", param);
}

function alias_get(param = {}) {
  return wsService.make_post_request(section + "/alias/get", param);
}
export const settingsService = {
  section,
  filter,
  update,
  create,
  getLogo,
  alias_get_map,
  alias_get
};
